import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_ModalBusinessFeatures = _resolveComponent("ModalBusinessFeatures")!
  const _component_UpgradePlanWithoutPermission = _resolveComponent("UpgradePlanWithoutPermission")!

  return (_ctx.accountId)
    ? (_openBlock(), _createElementBlock("div", {
        id: "layout",
        key: _ctx.forceUpdateLayout,
        class: "layout"
      }, [
        _createVNode(_component_Header),
        _createVNode(_component_Alert),
        _createVNode(_component_router_view),
        (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
          _createVNode(_component_ModalBusinessFeatures),
          _createVNode(_component_UpgradePlanWithoutPermission)
        ]))
      ]))
    : _createCommentVNode("", true)
}